<div class="dialog-content-max">
<div [innerHTML]="text"></div>
<div class="custom-dialog-footer">
    <p-button class="m-1" label="Close" styleClass="customeclose" (click)="closemodal()"></p-button>

</div>
</div>
